import React, { useState, useEffect } from 'react';
import { Flex, Spin, Typography } from 'antd';
import { useParams } from 'react-router-dom';

import EmptyTable from 'Components/commonComponents/EmptyTable';

import getIndividualQuotation from 'Api/actions/quotation/getIndividualQuotation';

import TablePackage from './newComponent/TablePackages';
import TableCoverages from './newComponent/TableCoverages';
import HeaderQuotationComparatorsDiff from './newComponent/HeaderQuotationComparatorsDiff';

const { Text } = Typography;

const ComparatorDiff = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [quotationState, setQuotationState] = useState({
    insurance_carrier_quotations: [],
    coverages: [],
    assists: [],
    pdf_public_url: null,
  });

  useEffect(() => {
    // Consultar la información del package
    setLoading(true);
    getIndividualQuotation(id)
      .then((quotationData) => {
        setLoading(false);
        setQuotationState(quotationData);
      }).catch(() => {
        setLoading(false);
        setError('No pudimos consultar la información de la cotización :(');
      });
  }, []);


  if (error) return <h1>{error}</h1>;

  if (loading) {
    return (
      <Flex align='center' justify='center' gap='small' vertical style={{ height: '100%', minHeight: 200 }}>
        <Spin size='large' />
        <Text>Cargando...</Text>
      </Flex>
    );
  }

  // SOLO se filtran los paquetes seleccionados
  const selectedPackages = quotationState.insurance_carrier_quotations.filter((paquete) => paquete.selected);

  return (
    <div>
      <HeaderQuotationComparatorsDiff actionsDisabled={!selectedPackages.length} quotationId={id} urlPdf={quotationState.pdf_public_url} />
      {!selectedPackages.length && <EmptyTable message="Esta cotización no cuenta con paquetes seleccionados" />}
      {!!selectedPackages.length && (
        <>
          <TablePackage packages={selectedPackages} />
          <TableCoverages packages={selectedPackages} coverages={quotationState.coverages} assists={quotationState.assists} />
        </>
      )}
    </div>
  );
};

ComparatorDiff.propTypes = {};

export default ComparatorDiff;
